import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import FormField from './FormField';
import { useAuth } from '../util/auth';
import { useForm } from 'react-hook-form';
import AppTextField from '../components/Common/AppTextField';
function SettingsPassword({ onStatus }) {
  const auth = useAuth();
  const [pending, setPending] = useState(false);

  const { handleSubmit, control, getValues } = useForm({
    defaultValues: {
      pass: '',
      confirmPass: ''
    }
  });
  const onSubmit = (data) => {
    // Show pending indicator
    setPending(true);

    auth
      .updatePassword(data.pass)
      .then(() => {
        // Clear form
        reset();
        // Set success status
        onStatus({
          type: 'success',
          message: 'Your password has been updated'
        });
      })
      .catch((error) => {
        if (error.code === 'auth/requires-recent-login') {
          // Update state to show re-authentication modal
          onStatus({
            type: 'requires-recent-login',
            // Resubmit after reauth flow
            callback: () => onSubmit({ pass: data.pass })
          });
        } else {
          // Set error status
          onStatus({
            type: 'error',
            message: error.message
          });
        }
      })
      .finally(() => {
        // Hide pending indicator
        setPending(false);
      });
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Form.Group controlId="formName">
        <AppTextField
          name="pass"
          control={control}
          rules={{ required: 'Please enter a password' }}
          placeholder="New Password"
          type="password"
        />
      </Form.Group>
      <Form.Group controlId="formEmail">
        <AppTextField
          name="confirmPass"
          control={control}
          placeholder="Confirm New Password"
          rules={{
            required: 'Please enter your password again',
            validate: (value) => {
              const { pass } = getValues();
              return pass === value || "This doesn't match your password";
            }
          }}
          type="password"
        />
      </Form.Group>
      <Button type="submit" size="lg" disabled={pending}>
        <span>Save</span>

        {pending && (
          <Spinner
            animation="border"
            size="sm"
            role="status"
            aria-hidden
            className="ml-2 align-baseline"
          >
            <span className="sr-only">Sending...</span>
          </Spinner>
        )}
      </Button>
    </Form>
  );
}

SettingsPassword.propTypes = {
  onStatus: PropTypes.func.isRequired
};

export default SettingsPassword;
